module.exports = "pegasus_template/assets/theme6/header-image.jpg";